import React from 'react';
import Navbar from '@/components/Navbar';
import GlobalBanner from '@/components/GlobalBanner';
import HeroSection from '@/components/HeroSection';
import TrustBar from '@/components/TrustBar';
import ServicesSection from '@/components/ServicesSection';
import WhyUsSection from '@/components/WhyUsSection';
import TestimonialsSection from '@/components/TestimonialsSection';
import FAQSection from '@/components/FAQSection';
import Footer from '@/components/Footer';
import InstantEstimateSection from '@/components/InstantEstimateSection';
import SEOParagraph from '@/components/SEOParagraph';
import HomeownerTools from '@/components/HomeownerTools';
import LocalHVACResource from '@/components/LocalHVACResource';
import TrustBuilder from '@/components/TrustBuilder';
import HowItWorks from '@/components/HowItWorks';
import ContractorBanner from '@/components/ContractorBanner';
import CommonProblemsStrip from '@/components/CommonProblemsStrip';
import PageSEO from '@/components/PageSEO';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <PageSEO breadcrumbs={[{ name: 'Home', url: '/' }]} />
      <GlobalBanner />
      <Navbar />
      <HeroSection />
      <LocalHVACResource />
      <InstantEstimateSection />
      <TrustBar />
      <HomeownerTools />
      <HowItWorks />
      <ServicesSection />
      <TrustBuilder />
      <CommonProblemsStrip />
      <WhyUsSection />
      <TestimonialsSection />
      <SEOParagraph />
      <ContractorBanner />
      <FAQSection />
      <Footer />
    </div>
  );
};

export default HomePage;
